import "./NonRepetitionClause.css";
import * as lang from "./lang.json";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import {Button} from "@experta/commons-v2.button";
import {Input} from "@experta/commons-v2.input";
import {Checkbox} from "@experta/commons-v2.checkbox";
import { NonRepetitionClauseForm, NonRepetitionClauseFormProps, validateForm } from "./utils";


/**
 * Main component.
 * @name NonRepetitionClause
 * @param {NonRepetitionClauseFormProps}
 * @returns {<NonRepetitionClause />}
 */

const NonRepetitionClause = ({
  onChange = (data: any) => {},
}: NonRepetitionClauseFormProps, ref: any) => {
  const [check, setCheck] = useState(false);
  const [formData, setFormData] = useState<NonRepetitionClauseForm>([]);
  const handleChange = (e: any, index: number) => {
    const newFormData = [...formData];
    (newFormData as any)[index][e.target.name] = e.target.value;
    setFormData(newFormData);
  };

  const addCompany = () => {
    const newFormData = [...formData, { cuit: "", businessName: "", errorsMessages: [] }];
    setFormData(newFormData);
  };

  const deleteCompany = (index: number) => {
    const newFormData = [...formData];
    newFormData.splice(index, 1);
    setFormData(newFormData);
  };

  useEffect(() => {
    if (!check) {
      setFormData([]);
    } else {
      setFormData([{ cuit: "", businessName: "", errorsMessages: [] }]);
    }
  }, [check]);

  useEffect(() => {
    onChange(formData);
  }, [formData]);

  const hasError = (item :any, name: string) => {
    return item.errorsMessages.filter((el: any) => el.field === name).length > 0;
  };

  const getError = (item :any, name: string) => {
    if(hasError(item, name)){
      return item.errorsMessages.filter((el: any) => el.field === name)[0].message;
    }
    else {
      return undefined;
    }
  };

  useImperativeHandle(ref, () => ({
    validateForm: () => {

      let currentForm: NonRepetitionClauseForm = validateForm(formData);
      setFormData([...currentForm]);
      const hasNonRepetitionClauseErrors = currentForm.filter(a => a.errorsMessages.length > 0).length > 0;      
      if(hasNonRepetitionClauseErrors) {
        return false;
      }   
      
      return true;
    }
  }), [formData]);
  
  return (
    <div className="non-repetition-clause-container mt-3">
      <div className="d-inline-flex mt-3 mb-3">
        <Checkbox checked={check} onChange={() => setCheck(!check)} />
        <span className="ml-3">
          <label className="check-label">
            {lang.checkText}
            <b>{lang.checkTextBold}</b>
          </label>
          <p className="check-label-legal ml-0 mr-0 mt-2">
            {lang.checkTextLegal}
          </p>
        </span>
      </div>
      {check && formData.length > 0 && (
        <div className="row">
          <div className="col-md-5 col-12">
            <Input
              name="cuit"
              label={lang.cuit}
              onChange={(e: any) => handleChange(e, 0)}
              value={formData[0].cuit}
              type="text"
              error={hasError(formData[0], "cuit")}
              errorMessage={getError(formData[0], "cuit")}
            />
          </div>
          <div className="col-md-5 col-12">
            <Input
              name="businessName"
              label={lang.businessName}
              onChange={(e: any) => handleChange(e, 0)}
              value={formData[0].businessName}
              type="text"
              error={hasError(formData[0], "businessName")}
              errorMessage={getError(formData[0], "businessName")}
            />
          </div>
          <div className="col-md-2 col-12"></div>
          {formData.length > 0 &&
            formData.map((item: any, index: number) => {
              if (index === 0) {
                return <></>;
              } else {
                return (
                  <>
                    <div className="col-md-5 col-12">
                      <Input
                        name="cuit"
                        label={lang.cuit}
                        onChange={(e: any) => handleChange(e, index)}
                        value={item.cuit}
                        type="text"
                        error={hasError(item, "cuit")}
                        errorMessage={getError(item, "cuit")}
                      />
                    </div>
                    <div className="col-md-5 col-12">
                      <Input
                        name="businessName"
                        label={lang.businessName}
                        onChange={(e: any) => handleChange(e, index)}
                        value={item.businessName}
                        type="text"
                        error={hasError(item, "businessName")}
                        errorMessage={getError(item, "businessName")}
                      />
                    </div>
                    <div className="col-md-2 col-12 d-flex justify-content-md-start justify-content-center">
                      <Button className="col-md-12 col-10 button-secondary-outline-ap mb-3" onClick={() => deleteCompany(index)}>
                        {lang.deleteCompany}
                      </Button>
                    </div>
                  </>
                );
              }
            })}
          <div className="col-md-4 col-12 d-flex justify-content-md-start justify-content-center">
            <Button className="col-10 button-secondary-outline-ap" onClick={() => addCompany()}>{lang.addCompany}</Button>
          </div>
          <div className="col-md-8 col-12"></div>
        </div>
      )}
    </div>
  );
};

export default forwardRef(NonRepetitionClause);
